import { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Badge } from "@mui/material";
import { FaRegCommentDots } from "react-icons/fa";
import {
  RiArrowLeftSLine,
  RiVipDiamondFill,
  RiBarChart2Fill,
  RiShoppingCartFill,
  RiGlobalFill,
  RiPaintBrushFill,
  RiBook2Fill,
  RiCalendarFill,
  RiServiceFill,
  RiNotification2Fill,
  RiUserSettingsFill,
  RiQuestionFill,
  RiStoreFill,
  RiMessage2Fill,
  RiImageFill,
  RiGroupFill,
  RiNewspaperFill,
  RiHandHeartFill,
  RiShoppingBagFill,
  RiBuildingFill,
  RiFileChartFill,
  RiFlagFill,
  RiFlashlightFill,
  RiQuestionnaireFill,
} from "react-icons/ri";
import "./Prosidebar.css";
import { ListReportIssues } from "../Header/Data3";
import { fetchPendingCaid } from "../../redux/slices/UserStateSlice";
import Tooltip from "./tooltip";

const ANIMATION_DURATION = 300;

const Prosidebar = ({
  collapsed,
  setCollapsed,
  toggled,
  setToggled,
  isMobileView,
  isTabletView,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const subMenuRefs = useRef([]);
  const firstSubMenuBtnRefs = useRef([]);
  const innerSubMenuBtnRefs = useRef([]);
  const isFetchingRef = useRef(false);
  const [rows, setRows] = useState(null);
  const { sidebarCounts } = useSelector((state) => state.user);
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const id = user?.Gurudwara;
  const isAdmin = user && user.Role === "admin";
  const isVendor = user && user.Role === "provider";
  const isCustomer = user && user.Role === "customer";
  const logUser = user?.Role;
  // const logUser = localStorage.getItem("USER_ROLE")
  const { pendingTemps } = useSelector((state) => state.templates);
  const { imageData } = useSelector((state) => state.image);
  const { customerInitiatedServices } = useSelector((state) => state.setting);
  const { loadingUsers, pendingCaidCount } = useSelector(
    (state) => state.userSettingsCount,
  );
  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );
  const filterPending =
    rows && rows.filter((row) => row.reportStatus === "Pending");
  const pendingImages =
    imageData && imageData.filter((image) => image.image_status === 0);
  const hasCustomerInitiated = customerInitiatedServices.some(
    (service) => service.customerInitiated === 1,
  );

  // Define sidebar items with icons
  const sidebarItems = [
    {
      id: 1,
      title: "Dashboard",
      link: "/dashboardpage",
      icon: <RiBarChart2Fill />,
    },
    {
      id: 2,
      title: "My Services for Sale",
      link: "/dashboardpage/my-services",
      icon: <RiServiceFill />,
    },
    {
      id: 3,
      title: "Flash Deals",
      link: "/dashboardpage/flash-Deals",
      icon: <RiFlashlightFill />,
    },
    {
      id: 4,
      title: "Calendar",
      link: "/dashboardpage/calendar",
      icon: <RiCalendarFill />,
    },
    {
      id: 5,
      title: "My Needs/Requests",
      link: "/dashboardpage/needs-requests",
      icon: <RiHandHeartFill />,
    },
    {
      id: 6,
      title: "Orders",
      link: "/dashboardpage/orders",
      icon: <RiShoppingCartFill />,
    },
    {
      id: 7,
      title: "Inbox",
      link: "/dashboardpage/inbox",
      icon: <RiMessage2Fill />,
    },
    {
      id: 18,
      title: "Media Templates",
      link: "/dashboardpage/media-templates",
      icon: <RiImageFill />,
    },
    {
      id: 8,
      title: "Settings",
      link: "/dashboardpage/settings",
      icon: <RiPaintBrushFill />,
    },
    {
      id: 9,
      title: "Sponsored Ads",
      link: "/dashboardpage/sponsored-ads",
      icon: <RiStoreFill />,
    },
    {
      id: 14,
      title: "Items For Sale",
      link: "/dashboardpage/my-items",
      icon: <RiShoppingBagFill />,
    },
    ...(isAdmin
      ? [
          {
            id: 18,
            title: "Comments Section",
            link: "/dashboardpage/comments-section",
            icon: <FaRegCommentDots />,
          },
          {
            id: 28,
            title: "Vendor Questions",
            link: "/admin/vendor-questions",
            icon: <RiQuestionnaireFill />,
          },
          {
            id: 11,
            title: "User Management",
            link: "/admin/usermanagement",
            icon: <RiUserSettingsFill />,
          },
          {
            id: 12,
            title: "Category Management",
            link: "/admin/categorymanagement",
            icon: <RiBook2Fill />,
          },
          {
            id: 13,
            title: "Category Questions",
            link: "/admin/questions",
            icon: <RiQuestionFill />,
          },
          {
            id: 16,
            title: "Gurdwara Management",
            link: "/dashboardpage/gurdwaramanagement",
            icon: <RiBuildingFill />,
          },
          {
            id: 22,
            title: "Gurdwara News",
            link: "/dashboardpage/gurdwaraNews",
            icon: <RiNewspaperFill />,
          },
          {
            id: 24,
            title: "Report Management",
            link: "/dashboardpage/reportalllogs",
            icon: <RiFlagFill />,
          },
          {
            id: 25,
            title: "Reports",
            link: "/dashboardpage/reports",
            icon: <RiFileChartFill />,
          },
          // {
          //   id: 25,
          //   title: "Reports",
          //   link: "/dashboardpage/all-reports",
          //   icon: <RiFileChartFill />,
          // },
        ]
      : [
          {
            id: 10,
            title: "My Favorites",
            link: "/dashboardpage/myFavorites",
            icon: <RiVipDiamondFill />,
          },
        ]),
    ...(isVendor
      ? [
          hasCustomerInitiated
            ? {
                id: 27,
                title: "Customers Initiated",
                link: "/dashboardpage/customerinitiated",
                icon: <RiGroupFill />,
              }
            : {},
        ]
      : []),
    {
      id: 15,
      title: "Notify List",
      link: "/dashboardpage/notifyList",
      icon: <RiNotification2Fill />,
    },
    ...(!isAdmin && id !== 0
      ? [
          {
            id: 16,
            title: "Gurdwara Management",
            link: "/dashboardpage/gurdwaramanagement",
            icon: <RiBuildingFill />,
          },
          {
            id: 21,
            title: "Gurdwara News",
            link: "/dashboardpage/gurdwaraNews",
            icon: <RiNewspaperFill />,
          },
        ]
      : []),
    {
      id: 17,
      title: "Message Templates",
      link: "/dashboardpage/message-templates",
      icon: <RiMessage2Fill />,
    },
    ...(!isCustomer
      ? [
          {
            id: 26,
            title: "Auto Schedule Messages",
            link: "/dashboardpage/autoScheduleMessages",
            icon: <RiCalendarFill />,
          },
        ]
      : []),
    {
      id: 19,
      title: "Community Discussions",
      link: "/dashboardpage/community-discussions/local-newspapers",
      icon: <RiGroupFill />,
    },
    {
      id: 20,
      title: "Community WebSites",
      link: "/dashboardpage/community-websites",
      icon: <RiGlobalFill />,
    },
  ];

  const filteredItems = sidebarItems.filter(
    (item) => Object.keys(item).length > 0,
  );

  const handleItemClick = (item) => {
    if (item.link !== "/dashboardpage/settings" && !isProfileComplete) {
       if (!location.pathname.includes("/dashboardpage/settings")) {
        navigate("/dashboardpage/settings");
      }
      toast.info("Please complete your profile.");
      return;
    }
    navigate(item.link);
    if (toggled) {
      setToggled(false); // Close sidebar on mobile/tablet after clicking
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        (isMobileView || isTabletView) &&
        toggled &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".psb-mobile-trigger") // Don't close if clicking the trigger
      ) {
        setToggled(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [toggled, isMobileView, isTabletView, setToggled]);

  return (
    <aside
      id="psb-sidebar"
      className={`psb-sidebar psb-has-bg-image ${
        collapsed && !isMobileView && !isTabletView
          ? "psb-collapsed-desktop"
          : ""
      } ${toggled ? "psb-toggled" : ""}`}
      ref={sidebarRef}
    >
      <div className="psb-layout px-4 pb-4">
        <div className="psb-content">
          {/* Mobile/Tablet close button - show only when sidebar is toggled open */}
          {(isMobileView || isTabletView) && toggled && (
            <div
              className="psb-mobile-close-btn text-2xl p-1 cursor-pointer"
              onClick={() => setToggled(false)}
            >
              <RiArrowLeftSLine />
            </div>
          )}
          <nav className="psb-menu psb-open-current-submenu">
            <ul>
              <li className="psb-menu-header">
                <span>GENERAL</span>
              </li>
              {filteredItems.map((item) => (
                <li
                  key={item.id}
                  className={`psb-menu-item rounded ${
                    location.pathname === item.link ||
                    (location.pathname.startsWith(item.link + "/") &&
                      item.link !== "/dashboardpage")
                      ? "psb-active"
                      : ""
                  }`}
                  onClick={() => handleItemClick(item)} // Added onClick to the entire li
                >
                  <Tooltip
                    text={item.title}
                    visible={
                      (collapsed && !toggled && !isMobileView) ||
                      (isTabletView && !toggled)
                    }
                  >
                    <a>
                      <span className="psb-icon">{item.icon}</span>
                      {!(collapsed && !isMobileView && !isTabletView) && ( // Hide title if desktop collapsed
                        <span className="psb-title-container">
                          <span className="psb-title">{item.title}</span>
                          {item.title === "My Needs/Requests" &&
                            sidebarCounts.needCount !== "0" && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={sidebarCounts.needCount}
                                  color="error"
                                />
                              </span>
                            )}
                          {item.title === "My Services for Sale" &&
                            sidebarCounts.serviceCount !== "0" && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={sidebarCounts.serviceCount}
                                  color="error"
                                />
                              </span>
                            )}
                          {item.title === "Media Templates" &&
                            sidebarCounts.imageCount !== "0" && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={sidebarCounts.imageCount}
                                  color="error"
                                />
                              </span>
                            )}
                          {item.title === "Inbox" &&
                            !isAdmin &&
                            sidebarCounts.messageCount !== "0" && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={sidebarCounts.messageCount}
                                  color="error"
                                />
                              </span>
                            )}

                          {isAdmin &&
                            item.title === "Settings" &&
                            sidebarCounts?.caidCount > 0 && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={sidebarCounts?.caidCount}
                                  color="error"
                                />
                              </span>
                            )}
                          {isAdmin &&
                            item.title === "Report Management" &&
                            filterPending?.length > 0 && (
                              <span className="psb-badge-container">
                                <Badge
                                  badgeContent={filterPending.length}
                                  color="error"
                                />
                              </span>
                            )}
                        </span>
                      )}
                    </a>
                  </Tooltip>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      {/* Desktop collapser button - only visible on desktop */}
      {!isMobileView && !isTabletView && (
        <a
          id="psb-btn-collapse"
          className="psb-collapser"
          onClick={() => setCollapsed((prev) => !prev)}
        >
          <RiArrowLeftSLine />
        </a>
      )}
    </aside>
  );
};

export default Prosidebar;
